import $ from 'jquery'
import details from './details'
import index from './index'
import store from '@/store'
import misc from '../misc'
import * as datetime from '../datetime'
import api from '@/api/Api'
import { bus } from '../../Bus'

export const get = (project, returnOnly, forceSync) => {
    let wait = $.Deferred()
    
    details.get(project, returnOnly, forceSync).then(
        (r) => {
            return wait.resolve({
                payments: r.orders || [],
                bpDetails: r.bpDetails || {}
            }).promise()
        },
        (err) => {
            return wait.reject(err).promise()
        }
    )
    
    return wait.promise()
}

export const download = (project, orderId) => {
    return index.download(project, 'order', orderId)
}

export const pendingCount = (project) => {
    let wait = $.Deferred()
    
    get(project).done((r) => {
        if(!r.payments)
            return wait.resolve(0).promise()
        else {
            let pending = 0
            
            $.each(r.payments, (i, v) => {
                if(v.status && /Pending/i.test(v.status))
                    pending++
            })
            
            return wait.resolve(pending).promise()
        }
    }).fail(() => {
        return wait.resolve(0).promise()
    })
    
    return wait.promise()
}

export const getPaymentFor = (type) => {
    let types = {
        project_registration: 'Registration',
        registration_with_certification: 'Registration and Certification',
        regular_review: 'Certification'
    }
    
    return types[type] ?types[type] :'Unknown'
}

export const payNowSupported = (currency, status) => {
    return status === 'Payment Pending'
}

const payProcessInfo = {
    project: {},
    order: {},
    processId: '',
    transOrderId: '',
    
    status: false,
    windowName: false,
    monitor: false
}

const openPaymentWindow = (url) => {
    if(payProcessInfo.status) {
        if(payProcessInfo.order.id)
            misc.blockScreen('Page will be auto refreshed when opened payment redirect window closed.')
        else
            misc.blockScreen('Waiting for response from payment gateway...')
        
        payProcessInfo.windowName.location.href = url
        
        return false
    }
    
    payProcessInfo.status = true
    
    let screenLeft = 0
    let screenTop = 0
    let width = parseInt((window.screen.width / 100) * 80)
    let height = parseInt((window.screen.height / 100) * 80)
    
    if(typeof window.screenLeft !== 'undefined') {
        screenLeft = window.screenLeft
        screenTop = window.screenTop
    }
    else if(typeof window.screenX !== 'undefined') {
        screenLeft = window.screenX
        screenTop = window.screenY
    }
    
    screenLeft = screenLeft + (window.screen.width - width) / 2
    screenTop = screenTop + (window.screen.height - height - 100) / 2
    
    payProcessInfo.windowName = window.open(url, 'paymentRedirect', 'status=yes,toolbar=no,menubar=no,location=no,addressbar=no,scrollbars=yes,resizable=yes,width='+width+'px,height='+height+'px,left='+screenLeft+',top='+screenTop)
    
    payProcessInfo.monitor = setInterval(function() {
        if(
            payProcessInfo.status === true
                &&
            payProcessInfo.windowName.closed
        ) {
            clearInterval(payProcessInfo.monitor)
            payProcessInfo.monitor = payProcessInfo.windowName = payProcessInfo.status = false
            misc.notify('E', "You've closed the payment processing window!", 'Payment Aborted')
            misc.releaseScreen()
        }
    }, 1000)
}

export const payInit = (project, order) => {
    payProcessInfo.project = project
    payProcessInfo.order = order
    payProcessInfo.processId = ''
    payProcessInfo.monitor = payProcessInfo.windowName = payProcessInfo.status = false
    
    let handlerPage = window.location.protocol+'//'+window.location.host+'/static/paynow.html?cmd='
    
    openPaymentWindow(handlerPage+'init')
    
    misc.blockScreen('Initializing... please wait.')
    
    return handlerPage
}

export const payInitReverse = () => {
    if(payProcessInfo.windowName) {
        clearInterval(payProcessInfo.monitor)
        payProcessInfo.windowName.close()
        payProcessInfo.monitor = payProcessInfo.windowName = payProcessInfo.status = false
    }
    
    misc.releaseScreen()
}

const _payProcess = (deferred) => {
    deferred.done((r) => {
        payProcessInfo.processId = r.data.processId
        openPaymentWindow(r.data.processUrl)
    }).fail((r) => {
        if(payProcessInfo.windowName) {
            clearInterval(payProcessInfo.monitor)
            payProcessInfo.windowName.close()
            payProcessInfo.monitor = payProcessInfo.windowName = payProcessInfo.status = false
        }
        
        misc.notify('E', api.getError(r), 'Error')
        misc.releaseScreen()
    })
}

export const makePayment = (handlerPage) => {
    payProcessInfo.transOrderId = ['M']
    payProcessInfo.transOrderId.push(store.getters['api/userInfo'].bpNumber.toString())
    payProcessInfo.transOrderId.push('T')
    payProcessInfo.transOrderId.push(datetime.default.date('mdHis', datetime.default.jsTimestampToGmt()).toString())
    payProcessInfo.transOrderId = payProcessInfo.transOrderId.join('')
    
    _payProcess(api.post('/Payments/setPayload', {
        programName: 'PEER',
        projectId: payProcessInfo.project.id,
        transOrderId: payProcessInfo.transOrderId,
        redirectUrl: encodeURIComponent(handlerPage+'response'),
        gatewayEnvironment: 'auto',
        reqPayload: payProcessInfo.order
    }, true, {}, api.CONTENT_TYPE_BODY))
}

export const doPayNow = (project, order) => {
    if(!payNowSupported(order.currency, order.status))
        return false
    
    let handlerPage = payInit(project, order)
    
    _payProcess(api.get('/Payments/programPayment', {
        programName: 'PEER',
        projectId: project.id,
        orderId: order.id,
        redirect: encodeURIComponent(handlerPage+'response')
    }, true))
}

export const paymentResponse = (d) => {
    if(payProcessInfo.windowName) {
        clearInterval(payProcessInfo.monitor)
        payProcessInfo.windowName.close()
        payProcessInfo.monitor = payProcessInfo.windowName = payProcessInfo.status = false
    }
    
    let releaseScreen = true
    
    if(d.transactionStatus === 'success') {
        bus.$emit('orderPaymentSuccessful', payProcessInfo)
        
        if(payProcessInfo.order.id)
            misc.notify('S', 'Transaction for the order# '+payProcessInfo.order.id+' is successful', 'Payment Successful')
        else
            releaseScreen = false
    }
    else {
        if(payProcessInfo.order.id) {
            misc.notify('E', 'Transaction for the order# '+payProcessInfo.order.id+' is '+d.transactionStatus+'<div style="margin-top:5px;">Details: '+d.transactionMsg+'</div>', 'Payment Failed', true)
        }
        else {
            misc.notify('E', 'Transaction is '+d.transactionStatus+'<div style="margin-top:5px;">Details: '+d.transactionMsg+'</div>', 'Payment Failed', true)
        }
    }
    
    if(releaseScreen)
        misc.releaseScreen()
}

export const getUploads = (project, cmd) => {
    if(cmd === 'cached')
        return index.files(project, 'order', true)
    
    let forceSync = cmd === 'forceSync'
    
    return index.files(project, 'order', {
        linkedTo: 'order',
        linksInfo: 4,
        total: 500
    }, forceSync)
}

export const resetUploads = (project) => {
    store.dispatch('files/reset', {
        type: 'order',
        id: project.id
    })
}

export default {
    get,
    download,
    pendingCount,
    getPaymentFor,
    payNowSupported,
    getUploads,
    resetUploads,
    payInit, payInitReverse, makePayment,
    doPayNow,
    paymentResponse
}
